import { render, staticRenderFns } from "./saldos_representantes.vue?vue&type=template&id=5a836d06&"
import script from "./saldos_representantes.vue?vue&type=script&lang=js&"
export * from "./saldos_representantes.vue?vue&type=script&lang=js&"
import style0 from "./saldos_representantes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports